/**
 * Whether the stacked switcher's previews are expanded.
 *
 * Kept outside the component because the switcher lives in the single-table
 * header, which is part of the PER-TABLE subtree: switching tables remounts it
 * and would reset any local `useState` to collapsed. The player asked for it
 * once and it should stay open until they close it — switching tables is the
 * very thing they opened it to do.
 *
 * Collapsing stays manual: tapping the badge, tapping outside, or Escape.
 */

let expanded = false;

export const isSwitcherExpanded = (): boolean => expanded;

export const setSwitcherExpanded = (value: boolean): void => {
  expanded = value;
};

/** Test seam — suites must not leak an expanded switcher into each other. */
export const resetSwitcherExpanded = (): void => {
  expanded = false;
};
